import * as Yup from "yup";

export const faqsSchema = Yup.object({
  faqs: Yup.array().of(
    Yup.object({
      question: Yup.string().trim().required("Question is required"),
      answer: Yup.string().trim().required("Answer is required"),
    })
  ),
});
